/**
 * Flamegraph Launcher Utilities
 *
 * Common utilities for launching flamegraph from time series charts.
 */

/**
 * Data point structure from Chart.js time series
 */
export interface DataPoint {
    x: Date;
    y: number;
    originalDate: string;  // Format: YYYY-MM-DD or YYYY-MM-DD/functionId/subType
    commitId?: string;
    isDeployed?: boolean;
    isActivated?: boolean;
}

/**
 * Extract time series data points from Chart.js chart instance
 *
 * @param chart - Chart.js chart instance
 * @returns Array of data points from the chart
 */
export function extractTimeSeriesData(chart: any): DataPoint[] {
    if (!chart || !chart.data || !chart.data.datasets || chart.data.datasets.length === 0) {
        return [];
    }

    const dataset = chart.data.datasets[0];
    if (!dataset.data || dataset.data.length === 0) {
        return [];
    }

    return dataset.data.map((point: any) => ({
        x: point.x instanceof Date ? point.x : new Date(point.x),
        y: point.y,
        originalDate: point.originalDate || (point.x instanceof Date ? point.x.toISOString().split('T')[0] : point.x),
        commitId: point.commitId,
        isDeployed: point.isDeployed,
        isActivated: point.isActivated
    }));
}
